<template>
  <div class="box-border has-background-white h-100-per" id="investmentSubBox">
    <div class="mg-b-5 line-title-dh is-flex is-justify-spacebetween">
      <b-tooltip
        label="Move"
        type="is-dark"
        v-if="user.userLevel == 0"
        position="is-bottom"
      >
        <p
          class="is-size-5 has-text-weight-normal pd-y-10 vue-draggable-handle"
        >
          {{ $t("dashboard.mainDashboardInvestmentSupport") }}
        </p>
      </b-tooltip>
      <p
        v-else
        class="is-size-5 has-text-weight-normal pd-y-10 vue-draggable-handle"
      >
        {{ $t("dashboard.mainDashboardInvestmentSupport") }}
      </p>
      <p
        class="pd-y-10 icon-color is-size-5 cr-pointer"
        @click="$emit('openModalInfo', 'im-s')"
      >
        <i class="fas fa-question-circle"></i>
      </p>
    </div>
    <div class="has-text-centered">
      <p
        v-if="
          (taskPendingRequest > 0 || taskApproveAmount > 0) &&
          (getRule !== 'exclusiveboard' ||
            (getRule == 'exclusiveboard' && batch.cat == 1))
        "
        class="d-inline-block is-size-3 is-size-4-mobile has-text-weight-normal pd-t-20 pd-b-20 mg-r-15 has-text-centered done-color th"
      >
        {{ $t("staffList.investmentSupportApproved") }}:
        <span title="Show at company">฿ {{ taskApproveAmount | comma }} </span>
        <span
          v-if="getRule !== 'startup' && typeof showCompany !== 'undefined'"
          class="pd-Approve"
          >/
        </span>
        <span
          v-if="getRule !== 'startup' && typeof showCompany !== 'undefined'"
          title="Full approved investment"
          >฿ {{ taskApproveAmountAll | comma }}</span
        >
      </p>
      <p
        v-if="
          (taskPendingRequest > 0 || taskApproveAmount > 0) &&
          (getRule !== 'exclusiveboard' ||
            (getRule == 'exclusiveboard' && batch.cat == 1))
        "
        class="d-inline-block is-size-3 is-size-4-mobile has-text-weight-normal pd-t-20 pd-b-20 has-text-centered text-grey-light th"
      >
        {{ $t("staffList.investmentSupportPending") }}:
        <span title="Show at company">฿ {{ taskPendingRequest | comma }} </span>
        <span
          v-if="getRule !== 'startup' && typeof showCompany !== 'undefined'"
          class="pd-Approve"
          >/
        </span>
        <span
          v-if="getRule !== 'startup' && typeof showCompany !== 'undefined'"
          title="Full pending investment"
          >฿ {{ taskPendingRequestAll | comma }}</span
        >
      </p>
    </div>

    <div
      v-if="taskPendingRequest > 0 || taskApproveAmount > 0"
      class="columns m-h-auto is-flex-wrap"
    >
      <div
        v-for="(item, index) in categories"
        :key="index"
        class="column is-6 pd-10"
      >
        <p
          class="th has-text-weight-normal over-text"
          :title="$i18n.locale === 'th' ? item.name : item.nameEN"
        >
          <span v-if="widthMax > 1366">{{
            $i18n.locale === "th" ? item.name : item.nameEN
          }}</span>
          <span v-else>{{
            $i18n.locale === "th" ? item.name : item.nameEN
          }}</span>
        </p>
        <div
          v-if="getRule == 'exclusiveboard' && batch.cat == 0"
          class="is-flex is-justify-spacebetween mg-b-5"
        >
          <p
            class="is-size-6"
            :title="$t('staffList.investmentSupportApproved')"
          >
            {{
              getPercenApprove(
                getApproveAmountTotal(item.id, "percent"),
                getPendingRequestTotal(item.id, "percent")
              )
            }}
            %
            <span class="is-widescreen-only"
              >({{ $t("staffList.investmentSupportApproved") }})</span
            >
          </p>
        </div>
        <div v-else class="is-flex is-justify-spacebetween mg-b-5">
          <p class="is-size-6">
            <span title="Show at company"
              >฿ {{ getApproveAmountTotal(item.id, "normal") | comma }}
            </span>
            <span
              v-if="getRule !== 'startup' && typeof showCompany !== 'undefined'"
              class="pd-Approve"
              >/
            </span>
            <span
              v-if="getRule !== 'startup' && typeof showCompany !== 'undefined'"
              :title="$t('dashboard.fullApprovedInvestment')"
              >฿
              {{
                getApproveAmountTotalInVisible(item.id, "normal") | comma
              }}</span
            >
            <span class="is-size-7 is-widescreen-only pd-Approve"
              >({{ $t("staffList.investmentSupportApproved") }})</span
            >
          </p>
          <p class="is-size-6">
            <span class="is-size-7 is-widescreen-only"
              >({{ $t("staffList.investmentSupportPending") }})</span
            >
            <span title="Show at company" class="pd-l-5"
              >฿ {{ getPendingRequestTotal(item.id, "normal") | comma }}
            </span>
            <span
              v-if="getRule !== 'startup' && typeof showCompany !== 'undefined'"
              title="Full Pending investment"
              ><span class="pd-Approve"> / </span>฿
              {{
                getPendingRequestTotalStaffAdmin(item.id, "normal") | comma
              }}</span
            >
          </p>
        </div>
        <div
          v-if="getRule !== 'startup' && typeof showCompany !== 'undefined'"
          class="line-progress-success"
          :style="
            'width:' +
            getPercenApprove(
              getApproveAmountTotalStaffAdmin(item.id, 'percent'),
              getPendingRequestTotalStaffAdmin(item.id, 'percent')
            ) +
            '%'
          "
        />

        <div
          v-else
          class="line-progress-success"
          :style="
            'width:' +
            getPercenApprove(
              getApproveAmountTotal(item.id, 'percent'),
              getPendingRequestTotal(item.id, 'percent')
            ) +
            '%'
          "
        />
        <div class="line-progress"></div>
      </div>
    </div>
    <div
      v-else
      class="has-text-centered th is-size-5 pd-20 is-flex is-align-center is-justify-center h-100-per"
    >
      <p>*** {{ $t("dashboard.notfound") }} ***</p>
    </div>
  </div>
</template>

<script>
import Doughnut from "@/charts/Doughnut";
export default {
  props: ["useBy", "activitysAllStartup", "tasksAllStartup", "showCompany"],
  components: {
    Doughnut,
  },
  computed: {
    batch() {
      return this.$store.state.batch;
    },
    getRule() {
      return this.$store.getters.getRule;
    },
    user() {
      return this.$store.state.user;
    },
    categories() {
      return this.$store.state.categories;
    },
    activitysAll() {
      return this.$store.state.activitysAll;
    },
    taskPendingRequestAll() {
      return this.taskPendingRequestStaffAdmin;
    },
    taskPendingRequest() {
      return this.taskPendingRequestInVisible;
    },
    taskApproveAmountAll() {
      return this.taskApproveAmountStaffAdmin;
    },
    taskApproveAmount() {
      return this.taskApproveAmountInVisible;
    },
    taskPendingRequestStaffAdmin() {
      let amount = 0;
      let tasks =
        typeof this.tasksAllStartup !== "undefined"
          ? this.tasksAllStartup
          : this.$store.getters.tasks;
      tasks.map((item) => {
        if (
          item.fundAmount !== null &&
          typeof item.fundAmount !== "undefined" &&
          item.fundAmount !== "" &&
          item.fundStatus !== 4 &&
          item.fundStatus !== 5 &&
          item.fundStatus !== 0 &&
          item.fundStatus !== 1
        ) {
          amount = amount + item.fundAmount;
        }
      });
      return amount;
    },
    taskPendingRequestInVisible() {
      let amount = 0;
      this.$store.getters.taskInVisible.map((item) => {
        if (
          item.fundAmount !== null &&
          typeof item.fundAmount !== "undefined" &&
          item.fundAmount !== "" &&
          item.fundStatus !== 4 &&
          item.fundStatus !== 5 &&
          item.fundStatus !== 0 &&
          item.fundStatus !== 1
        ) {
          amount = amount + item.fundAmount;
        }
      });

      return amount;
    },
    taskApproveAmountStaffAdmin() {
      let amount = 0;
      let tasks =
        typeof this.tasksAllStartup !== "undefined"
          ? this.tasksAllStartup
          : this.$store.getters.tasks;
      tasks.map((item) => {
        if (
          item.approveAmount !== null &&
          typeof item.approveAmount !== "undefined" &&
          item.approveAmount !== "" &&
          item.fundStatus !== 4 &&
          item.fundStatus === 5
        ) {
          amount = amount + item.approveAmount;
        }
      });
      return amount;
    },
    taskApproveAmountInVisible() {
      let amount = 0;
      this.$store.getters.taskInVisible.map((item) => {
        if (
          item.approveAmount !== null &&
          typeof item.approveAmount !== "undefined" &&
          item.approveAmount !== "" &&
          item.fundStatus !== 4 &&
          item.fundStatus === 5
        ) {
          amount = amount + item.approveAmount;
        }
      });

      return amount;
    },
  },
  data() {
    return {
      widthMax: window.innerWidth,
    };
  },
  methods: {
    getApproveAmountTotalStaffAdmin(id, type) {
      let task = [];
      let filterActivity = this.activitysAll.filter(
        (item) => item.categoryId === id
      );
      filterActivity.map((activity) => {
        let filterTask = this.$store.getters.tasks.filter(
          (task) =>
            task.activityId === activity._id &&
            task.fundStatus !== null &&
            task.fundStatus !== 0 &&
            task.fundStatus !== 4 &&
            ((type !== "normal" && task.fundStatus !== 1) ||
              (type === "normal" && task.fundStatus === 5))
        );
        filterTask.map((item) => {
          task.push(item);
        });
      });

      let amount = 0;
      task.map((item) => {
        if (
          item.approveAmount !== null &&
          typeof item.approveAmount !== "undefined" &&
          item.approveAmount !== ""
        ) {
          amount = amount + item.approveAmount;
        }
      });

      return amount;
    },
    getApproveAmountTotalInVisible(id, type) {
      let activityAll =
        this.useBy === "startup" ? this.activitysAll : this.activitysAllStartup;
      let taskAll = this.tasksAllStartup;
      let task = [];
      let filterActivity = activityAll.filter((item) => item.categoryId === id);
      filterActivity.map((activity) => {
        let filterTask = taskAll.filter(
          (task) =>
            task.activityId === activity._id &&
            task.fundStatus !== null &&
            task.fundStatus !== 0 &&
            task.fundStatus !== 4 &&
            ((type !== "normal" && task.fundStatus !== 1) ||
              (type === "normal" && task.fundStatus === 5))
        );
        filterTask.map((item) => {
          task.push(item);
        });
      });

      let amount = 0;
      task.map((item) => {
        if (
          item.approveAmount !== null &&
          typeof item.approveAmount !== "undefined" &&
          item.approveAmount !== ""
        ) {
          amount = amount + item.approveAmount;
        }
      });
      return amount;
    },
    getApproveAmountTotal(id, type) {
      let activityAll =
        this.useBy === "startup" ? this.activitysAll : this.activitysAllStartup;
      let taskAll = this.$store.getters.taskInVisible;
      let task = [];
      let filterActivity = activityAll.filter((item) => item.categoryId === id);
      filterActivity.map((activity) => {
        let filterTask = taskAll.filter(
          (task) =>
            task.activityId === activity._id &&
            task.fundStatus !== null &&
            task.fundStatus !== 0 &&
            task.fundStatus !== 4 &&
            ((type !== "normal" && task.fundStatus !== 1) ||
              (type === "normal" && task.fundStatus === 5))
        );
        filterTask.map((item) => {
          task.push(item);
        });
      });

      let amount = 0;
      task.map((item) => {
        if (
          item.approveAmount !== null &&
          typeof item.approveAmount !== "undefined" &&
          item.approveAmount !== ""
        ) {
          amount = amount + item.approveAmount;
        }
      });
      return amount;
    },
    getPendingRequestTotalStaffAdmin(id, type) {
      let task = [];
      let filterActivity = this.activitysAll.filter(
        (item) => item.categoryId === id
      );
      filterActivity.map((activity) => {
        let filterTask = this.$store.getters.tasks.filter(
          (task) =>
            task.activityId === activity._id &&
            task.fundStatus !== null &&
            task.fundStatus !== 0 &&
            task.fundStatus !== 4 &&
            ((type !== "normal" && task.fundStatus !== 1) ||
              (type === "normal" &&
                (task.fundStatus === 2 || task.fundStatus === 3)))
        );
        filterTask.map((item) => {
          task.push(item);
        });
      });

      let amount = 0;
      task.map((item) => {
        if (
          item.fundAmount !== null &&
          typeof item.fundAmount !== "undefined" &&
          item.fundAmount !== ""
        ) {
          if (item.fundStatus === 5) {
            if (
              item.approveAmount !== null &&
              typeof item.approveAmount !== "undefined" &&
              item.approveAmount !== ""
            ) {
              amount = amount + item.approveAmount;
            }
          } else {
            amount = amount + item.fundAmount;
          }
        }
      });
      return amount;
    },
    getPendingRequestTotal(id, type) {
      let activityAll =
        this.useBy === "startup" ? this.activitysAll : this.activitysAllStartup;
      let taskAll =
        this.useBy === "startup"
          ? this.$store.getters.taskInVisible
          : this.tasksAllStartup;

      let task = [];
      let filterActivity = activityAll.filter((item) => item.categoryId === id);
      filterActivity.map((activity) => {
        let filterTask = taskAll.filter(
          (task) =>
            task.activityId === activity._id &&
            task.fundStatus !== null &&
            task.fundStatus !== 0 &&
            task.fundStatus !== 4 &&
            ((type !== "normal" && task.fundStatus !== 1) ||
              (type === "normal" &&
                (task.fundStatus === 2 || task.fundStatus === 3)))
        );

        filterTask.map((item) => {
          task.push(item);
        });
      });

      let amount = 0;
      task.map((item) => {
        if (
          item.fundAmount !== null &&
          typeof item.fundAmount !== "undefined" &&
          item.fundAmount !== ""
        ) {
          if (item.fundStatus === 5) {
            if (
              item.approveAmount !== null &&
              typeof item.approveAmount !== "undefined" &&
              item.approveAmount !== ""
            ) {
              amount = amount + item.approveAmount;
            }
          } else {
            amount = amount + item.fundAmount;
          }
        }
      });

      return amount;
    },
    getPercenApprove(amount, total) {
      let resPercent = 0;
      if (amount > total) {
        resPercent = 100;
      } else {
        if (
          amount !== "" &&
          amount !== null &&
          typeof amount !== "undefined" &&
          typeof amount !== "" &&
          total !== "" &&
          total !== null &&
          typeof total !== "undefined" &&
          amount !== 0 &&
          total !== 0
        ) {
          resPercent = Math.round((amount * 100) / total);
        }
      }

      return resPercent;
    },
  },
};
</script>

<style scoped>
.line-progress {
  background: #c7c7c7;
  height: 2px;
  margin-left: 2px;
  margin-right: 2px;
}
.line-progress-success {
  height: 5px;
  background-color: #00a79d;
  position: relative;
  top: 3px;
  border-radius: 10px;
}
.pd-Approve {
  padding: 0px 5px;
}
</style>